import React from "react";
import { CssBaseline } from "@mui/material";
import { ThemeContextProvider } from "./ThemeProviderContext";
import { HelpWidget } from "./HelpWidget";

export function HelpWidgetExporter() {
  return (
    <ThemeContextProvider>
      <CssBaseline />
      <HelpWidget />
    </ThemeContextProvider>
  );
}
